<template>
<div class="container-fluid" style="margin-top:0px;">
  <form  v-on:submit.prevent="submit()">

        <div class="card text-white mb-3">
          <div  class="card-header bg-success">
            <h4><i  class="fas fa-edit mr-2" aria-hidden="true"></i>NUOVA PROMO</h4>
          </div>
          <div style="color:black" class="card-body">
            
            
            <div class="form-group">


            <div class="form-group">
              <label for="date_doc"><strong>Data Inizio</strong></label>
              <input required v-model="promo.start_at" type="date" class="form-control bold" placeholder="" >
            </div>

            <div class="form-group">
              <label for="date_doc"><strong>Data Fine</strong></label>
              <input required v-model="promo.end_at" type="date" class="form-control bold" placeholder="" >
            </div>
            



              <label for="number_doc"><strong>Descrizione</strong></label>
              <input v-model="promo.description" type="text" class="form-control bold" placeholder=""  required>
              <div class="invalid-feedback">Example invalid feedback text</div>
            </div>
            
            
            

            
          </div>
        </div>
        
        <button :disabled="bt_spinner" type="submit"   class="btn btn-success float-right mt-1 mb-2 mr-2">                    
          SALVA
          <i class="fas fa-save ml-2 mr-2" aria-hidden="true"></i>
          
           <span v-if="bt_spinner"  class="spinner-border spinner-border-sm ml-2"  role="status" aria-hidden="true"></span>
          </button>

         <button @click="$emit('close')" type="button"   class="btn btn-primary float-left mt-1 mb-2 mr-2">                    
        ANNULLA
          <i class="fas fa-undo ml-2 mr-2" aria-hidden="true"></i>
          
           
          </button>
           
      </form>

      
    <confirm-box v-if="cb.show">     
      <template v-slot:header>
        <strong>{{cb.title}}</strong>    
      </template>
      <template v-slot:body1>
        <h4>{{cb.msg1}}</h4>   
      </template>
      <template v-slot:footer>  
        <button @click="cb.show=false" type="button" class="btn btn-secondary">
          
          NO</button>
        <button @click="processModal()" type="button" data-dismiss="modal" class="btn btn-primary">SI</button>
      </template>    
    </confirm-box>  

    





<alert-box class="mt-2" @close="msg.title=''" v-bind:msg="msg"  ></alert-box>


<!-- MAIN DIV -->
</div>

</template>
<script>

import api            from '@/api'
import confirmBox     from '@/components/common/ConfirmBox.vue'

import alertBox       from '@/components/common/AlertBox.vue'

import { mapGetters } from 'vuex'
export default {
  
  components: {confirmBox,alertBox},  
  props: [],
  data () {
    return {
            
     
      promo           : {},    
      bt_spinner      : false,
      options         : [],          
      cb              : {title : '',msg1 : '',show:false},
      msg             : {title : '',body:'',type :0}
      

    }
  },

computed: 
  {
    ...mapGetters(['company']), 

  },
created()
{



  

},
methods: 
{   
  
  
  processModal()
  {
    
    this.cb.show = false

    this.$emit('update',this.doc)
  
  },

 
  async submit() 
  {
    


    this.msg.title = ''
   
    this.bt_spinner = true
    const data  = this.promo
    
        
    const sp   = {'sp':'spCreatePromo'}
    const json = Object.assign(data, sp,{'companyId':this.company.Id});
    
    
    
    await api.post(json).then(res => {
          
          if(res.status==200)
            {
              
              this.$emit('close')
              
            }
            else if(res.status==500)
            {
                
                this.msg.title = 'ATTENZIONE '
                this.msg.body = res.data
                this.msg.type = 1
                
                    
           } 
           else
            {
              
                
                this.msg.title = 'ATTENZIONE '
                this.msg.body = res
                this.msg.type = 1 
            } 
          

          }).catch(err => {
              
              
                
                this.msg.title = 'ATTENZIONE '
                this.msg.body = err.message
                this.msg.type = 1 
              
          }).finally(() => {
          this.bt_spinner = false
        });

	}
  
      
}
    
}    
</script>

<style scoped>




 
.bold {
  font-weight: bolder;
}

h4 {
  font-family : 'Roboto Condensed';
  font-size   : 20px;
}



</style>